import { CARD_TYPES } from 'cards/constants/CardTypes';

export const SUPPORTED_CARD_TYPES = [
  CARD_TYPES.std,
  CARD_TYPES.dstd,
  CARD_TYPES.thankyou,
  CARD_TYPES.holiday,
];

export const ZOLA_PLP_PHOTO_PREVIEW = 'ZOLA_PLP_PHOTO_PREVIEW';
export const PLP_PREVIEW_LIVE_PHOTO = 'PLP_PREVIEW_LIVE_PHOTO';
export const PLP_ADD_LIVE_PHOTO = 'PLP_ADD_LIVE_PHOTO';
export const PHOTO_PREVIEW_WALKTHROUGH_TRIGGERED = 'PHOTO_PREVIEW_WALKTHROUGH_TRIGGERED';
